// extracted by mini-css-extract-plugin
export default {"progressBar":"PasswordStrength_progressBar__PoITV","progressText":"PasswordStrength_progressText__sjqf2","progress":"PasswordStrength_progress__OG5En"};